/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 8007:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _require = __webpack_require__(51008),
  LandingContext = _require.LandingContext,
  LandingProvider = _require.LandingProvider;
module.exports = {
  LandingContext: LandingContext,
  LandingProvider: LandingProvider
};

/***/ }),

/***/ 51008:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _toConsumableArray = (__webpack_require__(46958)["default"]);
var _objectSpread = (__webpack_require__(91903)["default"]);
var _classCallCheck = (__webpack_require__(77537)["default"]);
var _createClass = (__webpack_require__(68765)["default"]);
var _callSuper = (__webpack_require__(93089)["default"]);
var _inherits = (__webpack_require__(45370)["default"]);
__webpack_require__(33114);
__webpack_require__(43133);
__webpack_require__(83790);
__webpack_require__(72341);
__webpack_require__(75538);
__webpack_require__(61000);
__webpack_require__(57037);
var React = __webpack_require__(16689);
var LandingContext = React.createContext();
var LandingProvider = /*#__PURE__*/function (_React$PureComponent) {
  "use strict";

  function LandingProvider(props) {
    var _props$landingData$is;
    var _this;
    _classCallCheck(this, LandingProvider);
    _this = _callSuper(this, LandingProvider, [props]);
    // TODO: Change this. Shouldn't be mocked
    var _props$landingData = props.landingData,
      _props$landingData$co = _props$landingData.components,
      components = _props$landingData$co === void 0 ? {} : _props$landingData$co,
      _props$landingData$se = _props$landingData.seo,
      seo = _props$landingData$se === void 0 ? {} : _props$landingData$se,
      _props$landingData$si = _props$landingData.site,
      site = _props$landingData$si === void 0 ? {} : _props$landingData$si,
      theme = _props$landingData.theme,
      folder = _props$landingData.folder,
      metrics = _props$landingData.metrics,
      vertical = _props$landingData.vertical,
      url = _props$landingData.url;
    var LandingConfig = {
      siteId: props.siteId,
      serverTime: new Date(props.serverTime ? Number(props.serverTime) : 0),
      showDealParam: props.showDealParam,
      isBottomSheetParam: props.isBottomSheetParam,
      lazyLoad: props.lazyLoad,
      deviceType: props.deviceType,
      webView: props.webView,
      seo: seo,
      webp: props.webp,
      lowEnd: props.lowEnd,
      pixelId: props.pixelId || '',
      pixelEnabled: true,
      googleTagManager: props.googleTagManager,
      analytics: site.analytics,
      theme: theme,
      validateDevices: props.validateDevices,
      osVersion: props.osVersion,
      osName: props.osName,
      folder: folder,
      metrics: metrics,
      platformType: props.platformType,
      jsDisabled: props.jsDisabled,
      title: props.title,
      vertical: vertical,
      url: url,
      isTakeover: (_props$landingData$is = props.landingData.isTakeover) !== null && _props$landingData$is !== void 0 ? _props$landingData$is : false
    };
    _this.updateLandingDataComponents = _this.updateLandingDataComponents.bind(_this);
    _this.prepareLandingDataComponents = _this.prepareLandingDataComponents.bind(_this);
    _this.updateLinkData = _this.updateLinkData.bind(_this);
    _this.updateDeviceType = _this.updateDeviceType.bind(_this);
    _this.state = _objectSpread(_objectSpread({}, props), {}, {
      updateLandingDataComponents: _this.updateLandingDataComponents,
      updateDeviceType: _this.updateDeviceType,
      landingData: {
        components: _toConsumableArray(_this.prepareLandingDataComponents(components))
      },
      landingConfig: LandingConfig
    });
    return _this;
  }

  /**
   * This method is provided in the context and updates the landingDataComponents in state.landingData.components
   * It's required when we are using a dynamic landingData (for example: in the splinter-admin formModule)
   * @param {array} landingDataComponents
   */
  _inherits(LandingProvider, _React$PureComponent);
  return _createClass(LandingProvider, [{
    key: "updateLandingDataComponents",
    value: function updateLandingDataComponents(landingDataComponents) {
      // TODO: this is wrong
      this.setState({
        landingData: {
          components: _toConsumableArray(this.prepareLandingDataComponents(landingDataComponents))
        }
      });
    }
  }, {
    key: "updateDeviceType",
    value: function updateDeviceType(deviceType) {
      // TODO: deviceType is duplicated.
      // Each component uses one or the other interchangeably, we should leave only one to be consistent
      this.setState({
        landingConfig: _objectSpread(_objectSpread({}, this.state.landingConfig), {}, {
          deviceType: deviceType
        }),
        deviceType: deviceType
      });
    }
  }, {
    key: "prepareLandingDataComponents",
    value: function prepareLandingDataComponents(components) {
      var _this2 = this;
      this.position = 0;
      return components.map(function (component) {
        _this2.updateLinkData(component);
        if (component.items) {
          component.items = component.items.map(function (item) {
            return _this2.updateLinkData(item);
          });
        }
        return component;
      });
    }
  }, {
    key: "updateLinkData",
    value: function updateLinkData(component) {
      var data = component.data,
        component_name = component.component_name,
        variations = component.variations;
      if (data && data.link || data && data.viewMoreLink) {
        var dataLink = data.link ? data.link : data.viewMoreLink;
        var link = _objectSpread(_objectSpread({}, dataLink), {}, {
          component: "".concat(component_name, "-").concat(variations),
          position: this.position
        });
        if (data.link) {
          data.link = link;
        } else {
          data.viewMoreLink = link;
        }
        this.position++;
      }
      return component;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx(LandingContext.Provider, {
        value: this.state
      }, void 0, this.props.children);
    }
  }]);
}(React.PureComponent);
LandingProvider.defaultProps = {
  lazyLoad: {
    enabled: true
  }
};
module.exports = {
  LandingContext: LandingContext,
  LandingProvider: LandingProvider
};

/***/ }),

/***/ 93089:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/callSuper");

/***/ }),

/***/ 77537:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 68765:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 45370:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 91903:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 46958:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/toConsumableArray");

/***/ }),

/***/ 33114:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.concat.js");

/***/ }),

/***/ 43133:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.map.js");

/***/ }),

/***/ 83790:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.constructor.js");

/***/ }),

/***/ 72341:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.map.js");

/***/ }),

/***/ 75538:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.number.constructor.js");

/***/ }),

/***/ 61000:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.to-string.js");

/***/ }),

/***/ 57037:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.link.js");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(8007);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map